module.exports = __webpack_public_path__ + "static/media/18pulgadasplastico.ae0db59c.jpg";